module.exports = __webpack_public_path__ + "img/BMWi.696ffb28.svg";